import { useMemo } from "react";
import { Spinner, Stack } from "@altimateai/lego";
import { useQuery } from '@tanstack/react-query';
import KnowledgeCatalogCard from "./KnowledgeCatalogCard";
import { getKnowledgeBaseTemplates } from "@/helpers/apis";
import { Card, CardHeader, CardContent, Typography } from "@altimateai/lego";

interface KnowledgeBaseTemplatesProps {
  searchQuery?: string;
}

const KnowledgeBaseTemplates = ({ searchQuery = "" }: KnowledgeBaseTemplatesProps) => {
  const { data: knowledgeTemplates, isLoading } = useQuery({
    queryKey: ["knowledgeTemplates"],
    queryFn: () => getKnowledgeBaseTemplates(),
  });

  const filteredTemplates = useMemo(() => {
    if (!knowledgeTemplates) return [];
    if (!searchQuery) return knowledgeTemplates;

    return knowledgeTemplates.filter(
      template =>
        template.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        template.description.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [knowledgeTemplates, searchQuery]);

  return (
    <Card>
      <CardHeader>
        <Typography variant="h4">Altimate Knowledge Documents</Typography>
      </CardHeader>
      <CardContent>
        <Stack direction="row" className="al-gap-4 !al-flex-wrap">
          {isLoading ? (
            <Spinner />
          ) : filteredTemplates?.length > 0 ? (
            filteredTemplates?.map(template => (
              <KnowledgeCatalogCard key={template.name} item={{ ...template, type: "template" }} />
            ))
          ) : (
            <Typography variant="body">
              {searchQuery ? "No templates match your search." : "No templates available."}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default KnowledgeBaseTemplates;
